import { driverMapEn } from './driverMap';
import { boltQualityEn } from './boltQuality';
import { claimsEn } from './claims';
export default {
  driverMap: driverMapEn,
  boltQuality: boltQualityEn,
  claims: claimsEn,
  nav: {
    driverMap: 'Driver map',
    dashboard: 'Dashboard',
    company: 'Company',
    subcompanies: 'Branches',
    bankAccounts: 'Bank Accounts',
    admins: 'Administrators',
    fleet: 'Fleet',
    driverFleet: 'Driver Fleet',
    crashes: 'Crashes',
    claims: 'Claims handling',
    fuelCards: 'Fuel Cards',
    inspections: 'Inspections',
    rentToOwn: 'Rent to own',
    drivers: 'Drivers',
    driversArchive: 'Archive',
    bonuses: 'Bonuses',
    invoices: 'Invoices for Acceptance',
    costInvoices: 'Cost Invoices',
    incomes: 'Incomes',
    documentTemplates: 'Document Templates',
    pendingDocuments: 'Pending Documents',
    driverOnboarding: 'Driver Onboarding',
    pendingDriversChanges: 'Pending Driver Changes',
    uploader: 'Importer',
    uploaderTemplates: 'Templates',
    importHistory: 'Import History',
    settlements: 'Settlements',
    contracts: 'Contract Payment',
    payouts: 'Payouts',
    dailyPayouts: 'Daily Payouts',
    selfServicePayouts: 'BLIK Payouts',
    boltSyncDrivers: 'Bolt Sync',
    receipts: 'Receipts',
    cashReport: 'Cash report',
    assistant: 'Office assistant',
    tasks: 'Tasks',
    notifications: 'Notifications',
    notificationLogs: 'Notification Logs',
    komornikLetters: 'Bailiff Management',
    policySales: 'Policy Sales',
    payoutConfig: 'Payout Config',
    wiki: 'Wiki',
    auditLogs: 'Audit Logs',
    systemSettings: 'System Settings',
    mailConfig: 'Email Configuration',
    appVersion: 'App Version',
    usageStats: 'Usage statistics',
    debtors: 'Debtors',
    integrations: 'API Integrations',
    chat: 'Chat',
    documentsRepository: 'Documents Repository',
    officialDocuments: 'Official documents',
    companyLicenses: 'TAXI licences',
    legalization: 'Residence legalisation',
    marketingPosts: 'Posts and graphics',
    announcements: 'Announcements',
    websiteLeads: 'Website leads',
    hr: 'HR',
    workTime: 'Work time',
    sms: 'SMS',
    accounting: 'Accounting',
    email: 'Email',
    wykazPojazdy: 'Vehicle Registry',
    wykazKierowcy: 'Driver Registry',
    staffActivity: 'Staff activity',
    pointsSettings: 'Points – Settings',
    pointsReferrals: 'Points – Referrals',
    pointsReviews: 'Points – Reviews',
    pointsRewardOrders: 'Points – Reward Orders',
    pointsDrivers: 'Points – Driver Balances',
    subFleet: 'Sub-Fleets',
    carRent: 'Car Rental',
    skippedImport: 'Skipped Imports',
    fleetDetails: 'Vehicle Details',
    driverDetails: 'Driver Details',
  },
  groups: {
    marketing: 'Marketing',
    firma: 'Company',
    administracja: 'Administration',
    flota: 'Fleet',
    kierowcy: 'Drivers',
    finanse: 'Finance',
    dokumenty: 'Documents',
    import: 'Import',
    komunikacja: 'Communication',
    wykazy: 'Registries',
    programPunktowy: 'Loyalty Program',
    ustawienia: 'Settings',
  },
  app: {
    menuConfig: 'Menu Configuration',
    accountSettings: 'Account settings',
    logout: 'LOGOUT',
    standalone: 'Standalone',
    unassignedPages: 'Unassigned pages',
    standalonePages: 'Standalone (no folder)',
    dragHint: 'Drag pages here...',
    standaloneDragHint: 'Drag pages here — they will appear without a folder',
    newGroupLabel: 'New group name',
    iconLabel: 'Icon',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    restoreDefaults: 'Restore defaults',
    menuConfigTitle: 'Menu groups configuration',
    searchPage: 'Search page...',
    switchCompany: 'Switch company',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No data',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    name: 'Name',
    description: 'Description',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    required: 'Required',
    all: 'All',
    perPage: 'Per page:',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    driver: 'Driver',
    download: 'Download',
    export: 'Export',
    preview: 'Preview',
    approve: 'Approve',
    reject: 'Reject',
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    expired: 'Expired',
    fieldRequired: 'This field is required',
    confirmDelete: 'Are you sure you want to delete?',
    refresh: 'Refresh',
    month: 'Month',
    year: 'Year',
    fitToWidth: 'Fit to width',
    addEntry: 'Add entry',
  },
  invoices: {
    title: 'Invoices',
    addButton: 'Add',
    docTypeLabel: 'Document type',
    docTypeInvoice: 'Invoice',
    docTypeConfirmation: 'Confirmation',
    docTypeSaved: 'Document type saved',
    acceptTitle: 'Invoice Acceptance',
    viewTitle: 'Invoice Preview',
    createTitle: 'Invoice Form',
    driverData: 'Driver invoice data',
    vatBreakdown: 'VAT Breakdown',
    driverReturn: 'Driver return',
    returnPercent: 'Return (%)',
    driverAmount: 'Driver amount',
    acceptBtn: 'Accept',
    companyBtn: 'Company',
    rejectBtn: 'Reject',
    previousInvoice: 'Previous',
    nextInvoice: 'Next',
    noFile: 'No file to preview',
    downloadFile: 'Download',
    csv: 'CSV',
    downloadFiles: 'Download files',
    headers: {
      date: 'Date',
      category: 'Category',
      taxRate: 'VAT Rate',
      brutto: 'Gross',
      netto: 'Net',
      vat: 'VAT Amount',
      driverCost: 'Driver Cost',
      driver: 'Driver',
      status: 'Status',
      file: 'File',
      description: 'Description',
      driverAmount: 'Driver amount',
      vatRateDriver: 'VAT Rate (from driver)',
    },
    statuses: {
      paid: 'Paid',
      payoutCreated: 'Payout Created',
      pending: 'Pending',
      accepted: 'Accepted',
      company: 'Company',
      rejected: 'Rejected',
    },
    tabs: {
      pending: 'To accept',
      accepted: 'Accepted',
      company: 'Company',
      rejected: 'Rejected',
    },
    categories: {
      FUEL: 'Fuel',
      CAR_PARTS: 'Car parts',
      SERVICE: 'Service / repair',
      OTHER: 'Other',
    },
    confirmReject: 'Reject invoice?',
    confirmRejectText: 'The invoice will be deleted.',
    confirmCompany: 'Accept as company invoice',
    confirmCompanyText: 'The invoice will be accepted as a company expense — the driver will not receive a refund and will see it as rejected.',
    acceptedMsg: 'Invoice has been accepted',
    companyMsg: 'Invoice accepted as company expense',
    rejectedMsg: 'Invoice has been rejected',
    noMore: 'No more invoices to accept.',
    confirmDelete: 'Delete invoice?',
    confirmCompanyBtn: 'Yes, accept as company',
    confirmRejectBtn: 'Yes, reject',
    downloadError: 'Failed to download file',
    loadError: 'Failed to load invoice',
    csvError: 'Failed to export CSV',
    zipError: 'Failed to download files',
    genericError: 'An error occurred',
  },
  websiteLeads: {
    title: 'Website leads',
    eyebrow: 'Contact centre',
    subtitle: 'Every enquiry from btpartner.pl — organised and ready for quick follow-up.',
    inboxLabel: 'Contact inbox',
    newShort: 'new',
    newCount: 'New',
    stats: {
      today: 'Today',
      last7: 'Last 7 days',
      last30: 'Last 30 days',
      total: 'Total',
      sectionLabel: 'Lead statistics',
      todayHint: 'received since midnight',
      last7Hint: 'received this week',
      last30Hint: 'received this month',
      totalHint: 'all saved contacts',
      chartTitle: 'Leads per day (30 days)',
      chartSubtitle: 'Contact form activity day by day',
      last30Short: '30 days',
      todayShort: 'today',
      noChartData: 'No data to display',
    },
    statusOverviewTitle: 'Handling status',
    statusOverviewSubtitle: 'Current distribution of all leads',
    listEyebrow: 'Current work',
    listTitle: 'Lead inbox',
    listSubtitle: 'Contact the candidate, save the outcome and keep track of the next step.',
    filterLabel: 'Lead status filter',
    searchPlaceholder: 'Search by person, phone, e-mail or message…',
    resultsPrefix: 'Leads in this view:',
    searchingFor: 'Results for',
    filterNew: 'New',
    filterInProgress: 'In progress',
    filterHandled: 'Handled',
    filterAll: 'All',
    statusNew: 'New',
    statusInProgress: 'In progress',
    statusHandled: 'Handled',
    markHandled: 'Mark handled',
    markInProgress: 'In progress',
    markNew: 'Restore',
    showFull: 'Show full message',
    openDetails: 'Open details',
    moreActions: 'More actions',
    changeStatus: 'Change status',
    detailsEyebrow: 'Lead details',
    messageTitle: 'Form message',
    messageSubtitle: 'The complete message submitted by the person contacting BTP',
    noMessage: 'No message was provided.',
    noEmail: 'No e-mail provided',
    noCity: 'No city provided',
    noNote: 'No internal note has been added yet.',
    noNoteSubtitle: 'Add the outcome of your contact with the candidate',
    lastHandledBy: 'Last handled by',
    emptyTitle: 'No leads in this view',
    emptySubtitle: 'Change the filter or clear the search to see the remaining contacts.',
    noteTitle: 'Lead note',
    noteHint: 'What is happening with this lead — e.g. "called, will call back tomorrow". Empty note = remove it.',
    noteAdd: 'Add note',
    noteEdit: 'Edit note',
    deleteTitle: 'Delete this lead?',
    deleteText: 'The lead will be permanently removed.',
    translateMessage: 'Translate to Polish',
    translationTitle: 'Translation (PL)',
    translationFrom: 'from language',
    contacts: {
      tab: 'Contacts',
      listTitle: 'Contact database',
      listSubtitle: 'Everyone who ever reached out — a list to contact in the future, e.g. when cars become available.',
      resultsPrefix: 'Contacts in the database:',
      leadsHeader: 'Leads',
      lastLeadHeader: 'Last lead',
      smsAction: 'SMS',
      emailAction: 'E-mail',
      exportCsv: 'Export CSV',
      emptyTitle: 'No contacts in the database',
      emptySubtitle: 'Contacts will appear here automatically after the first website lead.',
      bulk: {
        selected: 'Selected:',
        smsBtn: 'SMS to selected',
        emailBtn: 'E-mail to selected',
        clear: 'Clear selection',
        title: 'Bulk send',
        recipients: 'Recipients',
        skippedEmail: 'Skipped (no e-mail): {n}',
        skippedPhone: 'Skipped (no phone): {n}',
        sent: 'Sent to {n} recipients',
        partial: 'Sent {n} of {total}',
        failedList: 'Failed to send to:',
      },
    },
    reply: {
      smsAction: 'Reply via SMS',
      emailAction: 'Reply via e-mail',
      title: 'Reply to lead',
      channelLabel: 'Channel',
      langLabel: 'Send language',
      langPl: 'Polish',
      langEn: 'English',
      langUk: 'Ukrainian',
      langRu: 'Russian',
      langKa: 'Georgian',
      subjectLabel: 'E-mail subject',
      subjectPlaceholder: 'BTP Partner — reply to your inquiry',
      textLabel: 'Message — write in Polish',
      textPlaceholder: 'Write your reply in Polish…',
      translateBtn: 'Translate',
      translatedLabel: 'Will be sent (you can edit)',
      needTranslate: 'Translate the message before sending',
      send: 'Send',
      sent: 'Reply sent',
      historyTitle: 'Sent replies',
      historySubtitle: 'Correspondence history for this lead',
      historyEmpty: 'No replies sent yet.',
      original: 'Original (PL)',
      failed: 'Not sent',
      templateLabel: 'Reply template',
      templatePlaceholder: '— choose template —',
      templateSave: 'Save as template',
      templateSaveTitle: 'Template name',
      templateSaveHint: 'e.g. "No cars in city"',
      templateSaved: 'Template saved',
      templateDelete: 'Delete selected template',
      templateDeleteTitle: 'Delete template?',
      templateDeleteText: 'The template will disappear for the whole office.',
      tooLong: 'SMS too long — shorten it (limit: 918 chars without special characters, ~400 with them)',
      unicodeBecause: 'non-GSM characters:',
    },
    headers: {
      createdAt: 'Date',
      name: 'Name',
      phone: 'Phone',
      email: 'E-mail',
      city: 'City',
      message: 'Message',
      note: 'Note',
      status: 'Status',
      lead: 'Lead',
      contact: 'Contact',
      actions: 'Actions',
    },
  },
  announcements: {
    title: 'Announcements',
    addButton: 'Add announcement',
    editTitle: 'Edit announcement',
    newTitle: 'New announcement',
    contentLabel: 'Content *',
    expiresDateLabel: 'Valid until — date (optional)',
    expiresTimeLabel: 'Time',
    sendToAll: 'Send to all',
    subCompaniesLabel: 'Branches *',
    limitedAccess: 'You only have access to assigned branches',
    titleLabel: 'Title (visible only in admin panel)',
    headers: {
      title: 'Title',
      content: 'Content',
      createdAt: 'Created',
      expiresAt: 'Valid until',
      targets: 'Visibility',
      status: 'Status',
      author: 'Author',
    },
    statusActive: 'Active',
    statusExpired: 'Expired',
    noExpiry: 'No expiry',
    allTargets: 'All',
    confirmDelete: 'Delete announcement?',
  },
  driverOnboarding: {
    title: 'Driver Onboarding',
    searchPlaceholder: 'Search...',
    perPage: 'Per page:',
    pageText: '{0}-{1} of {2}',
    loadingText: 'Loading...',
    noDataText: 'No drivers pending acceptance',
    preview: 'Preview',
    accept: 'Accept',
    reject: 'Reject',
    acceptDriver: 'Accept Driver',
    rejectDriver: 'Reject Driver',
    tabs: {
      personalData: 'Personal Data',
      documents: 'Documents',
      zus: 'ZUS',
      consents: 'Consents',
    },
    editData: 'Edit data',
    contactData: 'Contact Data',
    basicData: 'Basic Data',
    address: 'Address',
    registration: 'Registration',
    onboardingStatus: 'Onboarding Status',
    labels: {
      email: 'Email',
      phone: 'Phone',
      emailVerified: 'Email verified',
      phoneVerified: 'Phone verified',
      firstName: 'First Name',
      lastName: 'Last Name',
      citizenship: 'Citizenship',
      language: 'Language',
      dateOfBirth: 'Date of birth',
      ownVehicle: 'Own vehicle',
      vehicleMake: 'Make',
      vehicleModel: 'Model',
      vehicleYear: 'Production year',
      vehiclePlate: 'Registration number',
      hasBusiness: 'Business activity',
      registerType: 'Registration method',
      referralCode: 'Referral code',
      bankAccount: 'Bank account number',
      payoutType: 'Payout type',
      street: 'Street',
      homeNumber: 'House number',
      aptNumber: 'Apartment number',
      postalCode: 'Postal code',
      city: 'City',
      registrationDate: 'Registration date',
      status: 'Status',
      assignedCompany: 'Assigned company',
      businessActivity: 'Business activity',
    },
    yes: 'Yes',
    no: 'No',
    none: 'None',
    addDocument: 'Add document',
    noDocuments: 'No uploaded documents',
    file: 'File',
    validUntil: 'Valid until',
    rejectionReason: 'Rejection reason',
    editZus: 'Edit ZUS',
    addZus: 'Add ZUS',
    noZusDeclarations: 'No ZUS declarations',
    zus: {
      employedElsewhere: 'Employed elsewhere',
      earnsAboveMinimum: 'Earns above minimum',
      student: 'Student',
      pensionRights: 'Pension rights',
      rentRights: 'Rent rights',
      voluntarySickness: 'Voluntary sickness insurance',
      registeredUnemployed: 'Registered unemployed',
      disabilityCert: 'Disability certificate',
      taxOffice: 'Tax office',
      nfzBranch: 'ZUS / KRUS',
    },
    accepted: 'Accepted',
    notAccepted: 'Not accepted',
    driverAcceptance: 'Driver Acceptance',
    acceptingDriver: 'You are accepting driver',
    company: 'Company',
    branch: 'Branch (optional)',
    selectCompany: 'Select company',
    driverRejection: 'Driver Rejection',
    confirmReject: 'Are you sure you want to reject driver',
    rejectionReasonOptional: 'Rejection reason (optional)',
    documentRejection: 'Document Rejection',
    rejectDocumentLabel: 'Reject document',
    rejectionReasonRequired: 'Rejection reason',
    provideRejectionReason: 'Provide rejection reason',
    rejectDocument: 'Reject Document',
    addDocumentTitle: 'Add document',
    documentType: 'Document type',
    fileLabel: 'File (JPG, PNG, PDF, max 25MB)',
    documentNumber: 'Document number (optional)',
    expiryDate: 'Expiry date (optional)',
    upload: 'Upload',
    cannotPreview: 'Cannot preview this file.',
  },
  driverPage: {
    title: 'Drivers',
    driverForm: 'Driver Form',
    labels: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      password: 'Password',
      phone: 'Phone',
      company: 'Company',
      department: 'Department',
    },
    searchLabel: 'Search',
  },
  driverDetails: {
    missingRequiredTitle: 'Not saved — required fields are missing',
    missingRequiredText: 'Fill in the fields below and save again:',
    missingRequiredFallback: 'Check the fields marked in red and save again.',
    tabs: {
      general: 'General Information',
      documents: 'Documents',
      invoices: 'Invoices',
      bonuses: 'Bonuses',
      carRental: 'Car Rental',
      importData: 'Import Data',
      payouts: 'Payouts',
      cars: 'Cars',
      bailiffs: 'Bailiffs',
      history: 'History',
      legalization: 'Legalisation',
    },
    generalInfo: 'General Information',
    labels: {
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      email: 'Email',
      password: 'Password',
      passwordHint: 'Leave empty to keep the current password',
      street: 'Street',
      homeNumber: 'House Number',
      aptNumber: 'Apartment Number',
      postalCode: 'Postal Code',
      city: 'City',
      licenseNumber: 'License Number',
      payoutType: 'Payout Type',
      payoutSchedule: 'Settlement Frequency',
      cooperationType: 'Cooperation Type',
      zusType: 'ZUS Type',
      accountNo: 'Account Number',
      accountNoHint: '26 digits without spaces or with spaces',
      abroadAccount: 'Abroad account?',
      readyForSettlements: 'Ready for settlements?',
      missingData: 'Missing Data',
      registerType: 'Registration Type',
      department: 'Department',
    },
    goBack: 'Back',
    driverDocuments: 'Driver Documents',
    addDocument: 'Add document',
    noDocuments: 'No documents',
    statusMissing: 'MISSING',
    statusAddedVerified: 'ADDED (verified)',
    statusRejected: 'REJECTED',
    statusAddedPending: 'ADDED (pending)',
    addBtn: 'Add',
    reAddBtn: 'Re-add',
    previewBtn: 'Preview',
    downloadBtn: 'Download',
    acceptBtn: 'Accept',
    rejectBtn: 'Reject',
    deleteBtn: 'Delete',
    uploadDocTitle: 'Add driver document',
    uploadDocType: 'Document type',
    uploadDocTypeRequired: 'Select document type',
    uploadDocNumber: 'Document number (optional)',
    uploadExpiryDate: 'Expiry date *',
    uploadExpiryRequired: 'Enter expiry date',
    uploadExpiryFuture: 'Date must be in the future',
    uploadFileLabel: 'File (JPG / PNG / WebP / PDF, max 25 MB)',
    uploadFileRequired: 'Select file',
    docPreviewTitle: 'Document Preview',
    invoicesTitle: 'Invoices',
    searchLabel: 'Search',
    bonusFormTitle: 'Bonus Form',
    bonusLabels: {
      file: 'File',
      date: 'Date',
      status: 'Status',
      type: 'Type',
      description: 'Description',
      amount: 'Amount',
    },
    bonusesTitle: 'Bonuses',
    downloadFile: 'Download file',
    carRentalTitle: 'Car Rental',
    importedDataTitle: 'Imported Data',
    equationTitle: 'Calculation Formula',
    formula: 'Formula',
    usedVariables: 'Used variables',
    constant: 'constant',
    calculationSteps: 'Calculation steps',
    calculationResult: 'Calculation result',
    csvData: 'CSV Data',
    field: 'Field',
    value: 'Value',
    noDataToDisplay: 'No data to display',
    payoutsTitle: 'Payouts',
    settlementSummary: 'Settlement Summary',
    paid: 'Paid',
    pendingStatus: 'Pending',
    bonusTypePositive: 'Bonus +',
    bonusTypeNegative: 'Penalty −',
    bonusTypeRent: 'Rent',
    settlementCalc: 'Settlement calculation',
    calcView: {
      title: 'Calculation of "total to settle"',
      appsEarnings: 'App earnings (sum of "Your income")',
      additionalIncomes: 'Additional income',
      bonusesPositive: 'Bonuses +',
      bonusesNegative: 'Bonuses −',
      rent: 'Rent (from bonuses)',
      cashCollected: 'Cash collected',
      cashCollectedHint: '(deducted — driver has it in hand)',
      settlementCost: 'Settlement cost',
      administrationTax: 'Administration fee',
      dailyAdvances: 'Daily advances ({count} ×)',
      dailyAdvancesHint: '(already paid out during the week)',
      dailyPayoutFees: 'Fast payout fees',
      dailyPayoutFeesHint: '({count} × 30 PLN)',
      zusContributions: 'ZUS contributions',
      maxCostReimbursement: 'Max cost reimbursement',
      maxCostReimbursementHint: '(8% × net from apps)',
      totalLabel: '= TOTAL',
    },
    revenues: 'REVENUES',
    fromApps: 'From apps (BOLT + UBER + FREENOW)',
    additionalIncomes: 'Additional incomes',
    bonusesPositive: 'Bonuses (+)',
    bonusesNegative: 'Bonuses (-)',
    rentFromBonuses: 'Rent (from bonuses)',
    tipsGross: 'Tips gross',
    tipsVat: 'VAT 23% on tips',
    invoiceReturn: 'Invoice return (max 8% net = {0})',
    settlementCost: 'Settlement cost',
    administrationFee: 'Administration fee',
    cashDeduction: 'Cash (deduction)',
    dailyAdvancesDeducted: 'Daily advances (already paid)',
    dailyPayoutFees: 'Daily payout fees (company collected)',
    maxCostReimbursement: 'Max cost reimbursement (8% net from apps)',
    finalReturnAmount: 'Final return amount',
    total: '= TOTAL',
    zusDeduction: 'ZUS DEDUCTION',
    zusCalc: {
      sickness: 'Sickness',
      social: 'Social',
      pitAdvance: 'PIT Advance',
      health: 'Health',
    },
    afterZus: '= After ZUS deduction',
    transferBreakdown: 'TRANSFER BREAKDOWN',
    contractTransfer: 'Contract payment',
    contractAlreadyPaid: 'Contract (already paid this month)',
    remainingAfterContract: 'Remaining after contract',
    costReimbursement: 'Cost reimbursement',
    rentTransfer: 'Rent',
    transfer: 'TRANSFER',
    invoiceTransfer: 'Invoice transfer',
    totalTransfers: 'TOTAL TRANSFERS (after ZUS)',
    infoNetto8pct: '8% net from apps',
    infoField: 'info field',
    perAppBreakdown: 'Per App Breakdown',
    appHeaders: {
      app: 'App',
      brutto: 'Gross',
      netto: 'Net',
      onePercentBrutto: '1% from Gross',
      eightPercentNetto: '8% from Net',
      calculated: 'Calculated',
      cash: 'Cash',
    },
    totalRow: 'TOTAL',
    zusDeductions: 'ZUS Deductions',
    zusHeaders: {
      monthYear: 'Month/Year',
      zusType: 'ZUS Type',
      sickness: 'Sickness',
      social: 'Social',
      laborFund: 'Labor Fund',
      health: 'Health',
      total: 'Total',
    },
    totalZus: 'TOTAL ZUS',
    quickStats: {
      total: 'Total',
      zus: 'ZUS',
      contract: 'Contract',
      costReimbursement: 'Cost reimbursement',
      maxCost8pct: 'max 8% net',
      rent: 'Rent',
    },
    appEarnings: 'App Earnings',
    summary: 'Summary',
    appId: 'App ID',
    cooperationType: 'Cooperation type',
    calculatedAmount: 'Calculated amount',
    cashLabel: 'Cash',
    csvDataFromFile: 'CSV Data',
    invoicesSection: 'Invoices',
    invoiceHeaders: {
      date: 'Date',
      brutto: 'Gross',
      forDriver: 'For Driver',
    },
    bonusesPenalties: 'Bonuses / Penalties',
    bonusHeaders: {
      description: 'Description',
      type: 'Type',
      amount: 'Amount',
    },
    incomesSection: 'Incomes',
    incomeHeaders: {
      date: 'Date',
      forDriver: 'For Driver',
    },
    noDetailedData: 'No detailed data for this settlement.',
    companyCars: 'Company Cars (assigned)',
    noCompanyCars: 'No company cars assigned to this driver.',
    mainCar: 'Main Car',
    additionalCar: 'Additional Car',
    carLabels: {
      makeModel: 'Make / Model',
      registration: 'Registration',
      sideNumber: 'Side number',
      color: 'Color',
      productionYear: 'Production year',
      wrapType: 'Wrap type',
      mileage: 'Mileage',
      rentPrice: 'Rent price',
    },
    licenseExcerpts: 'License excerpts',
    privateCars: 'Driver added cars (private)',
    noPrivateCars: 'No private cars',
    bailiffsTitle: 'Bailiffs',
    addBailiff: 'Add bailiff',
    editBailiff: 'Edit bailiff',
    noBailiffs: 'No bailiffs',
    bailiffLabels: {
      name: 'Bailiff name',
      accountNo: 'Account number',
      wireTitle: 'Transfer title',
      address1: 'Bailiff address',
      address2: 'Bailiff address cont.',
      transferTypes: 'Which transfer types',
      isActive: 'Active (transfers go to this bailiff)',
    },
    historyTitle: 'Driver History',
    cooperationTypeHistory: 'Cooperation Type History',
    changes: 'changes',
    equationLabel: 'Formula',
    current: 'Current',
    noHistory: 'No history - set cooperation type to start tracking changes.',
    uploadInvoiceTitle: 'Upload payout invoice',
    selectInvoiceFile: 'Select invoice file',
    uploadBtn: 'Upload',
    invoicePreviewTitle: 'Invoice Preview',
    uploaded: 'Uploaded',
    uploadInvoice: 'Upload Inv.',
    docPreview: 'Document Preview',
  },
  pendingChanges: {
    title: 'Pending Driver Changes',
    changesPerPage: 'Changes per page:',
    pageText: '{0}-{1} of {2}',
    loadingText: 'Loading changes...',
    noDataText: 'No changes to display',
    preview: 'Preview',
    approve: 'Approve',
    reject: 'Reject',
    rejectionReasonOptional: 'Rejection reason (optional)',
    changesPreview: 'Changes Preview',
    driverLabel: 'Driver',
    reportDate: 'Report date',
    currentValues: 'Current values',
    newValues: 'New values',
  },
  archiveDrivers: {
    title: 'Driver Archive',
    searchLabel: 'Search',
    department: 'Department',
  },
  bonusPage: {
    title: 'Bonuses',
    searchLabel: 'Search',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    driverLabel: 'Driver',
    downloadFile: 'Download file',
    bonusForm: 'Bonus Form',
    labels: {
      file: 'File',
      date: 'Date',
      driver: 'Driver',
      status: 'Status',
      type: 'Type',
      description: 'Description',
      amount: 'Amount',
    },
  },
  company: {
    title: 'Company',
    addCompany: 'Add company',
    editCompany: 'Edit company',
    newCompany: 'New company',
    address: 'Address',
    addressCont: 'Address cont.',
    zipCode: 'Zip Code',
    city: 'City',
    country: 'Country',
    taxCode: 'Tax ID',
    automaticPayouts: 'Automatic payouts',
  },
  subCompany: {
    title: 'Branches',
    addTitle: 'Add new',
    assignToAll: 'Assign branch to all administrators',
    assignToAllHint: 'New branch will be visible to every admin in the company',
  },
  admins: {
    title: 'Administrators',
    formTitle: 'Form',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    phone: 'Phone',
    mainCompany: 'Main company',
    mainCompanyHint: 'Default company after login',
    accessAllCompanies: 'Access to all companies',
    accessAllCompaniesHint: 'Administrator can switch between all companies in the system',
    additionalCompanies: 'Additional companies with access',
    additionalCompaniesHint: 'Companies the administrator can switch to (besides the main company)',
    branch: 'Branch',
    role: 'Role',
    pagePermissions: 'Page permissions',
    previewAll: 'Preview all',
    clear: 'Clear',
    page: 'Page',
    preview: 'Preview',
    editPerm: 'Edit',
    superadminHint: 'Superadministrator has full access regardless of selections.',
  },
  bankAccounts: {
    title: 'Bank Accounts',
    addAccountTitle: 'Add Account',
    accountNumber: 'Number',
    bankName: 'Bank Name',
    bankNameHint: 'Select from list or enter custom name',
    bankAccountNumberRule: 'Enter 26 digits (PL) or IBAN (e.g. DE89370400440532013000)',
  },
  login: {
    password: 'Password',
    loginButton: 'Login',
    enterEmail: 'Enter your e-mail address',
    enterPassword: 'Enter your password',
    failedTitle: 'Sign-in failed',
    invalidCredentials: 'Invalid e-mail or password. Check your details and try again.',
    genericError: 'Something went wrong. Please try again in a moment.',
    ok: 'Try again',
  },
  dashboard: {
    filters: 'Filters',
    branch: 'Branch',
    weekFrom: 'From week',
    weekTo: 'To week',
    settlementType: 'Settlement Type',
    drivers: 'Drivers',
    payoutsPeriod: 'Payouts (period)',
    pendingInvoices: 'Pending Invoices',
    zusAmountPeriod: 'ZUS Amount (period)',
    rentalIncome: 'Rental Income',
    vat8Net: '8% from driver earnings',
    onePercentGross: '1% of Gross',
    totalIncomes: 'Total Incomes',
    paid: 'Paid',
    toPay: 'To Pay',
    totalToPay: 'Total to Pay',
    published: 'Published',
    payoutsBySchedule: 'Payouts by Schedule',
    pending: 'Pending (gross)',
    pendingHint: 'Estimated gross — earnings of drivers with PENDING bonuses/imports in this range. Value BEFORE ZUS deduction (typically 50–500 zł per driver), so final payout will be slightly lower. Settlement cost + admin tax (30 zł) ARE already subtracted. After clicking "Rozlicz" in PayoutsPage the amount moves from "Pending" to "Total".',
    monthlyPending: 'Monthly — pending',
    monthlyPendingHint: 'Total estimated gross payouts for MONTHLY drivers in the current date range. Helpful for cashflow planning before end-of-month Rozlicz.',
    schedule: 'Schedule',
    count: 'Count',
    total: 'Total',
    statusPaid: 'Paid',
    statusPartial: 'Partial',
    statusPending: 'Pending',
    invoicesByVat: 'Invoices by VAT Rate',
    vatRate: 'VAT Rate',
    gross: 'Gross',
    net: 'Net',
    driverReturn: 'Driver return',
    incomeSummary: 'Income Summary',
    rentalIncomeTotal: 'Rental Income (total)',
    fromImports: '- from imports (CSV)',
    fromBonuses: '- from rental bonuses',
    fromSettlements: '- from settlements',
    vat8Income: '8% VAT Income',
    onePercentGrossCsv: '1% of Gross (CSV)',
    totalGrossImport: 'Total Gross from import',
    totalIncomesModel: 'Total Incomes (model)',
    paidIncomes: 'Paid incomes',
    unpaidIncomes: 'Unpaid incomes',
    driversByCoopType: 'Drivers by Cooperation Type',
    type: 'Type',
    driversByZusType: 'Drivers by ZUS Type',
    zusType: 'ZUS Type',
    payoutsByCoopType: 'Payouts by Cooperation Type (period)',
    amount: 'Amount',
    driversByPayoutSchedule: 'Drivers by Payout Schedule',
    recentPayouts: 'Recent Payouts (period)',
    recentInvoices: 'Recent Invoices for Acceptance',
    integrationsBlikTitle: 'API Integrations + BLIK Payouts',
    todayBlikRequests: 'Today BLIK requests',
    pendingApproval: 'Awaiting approval',
    reviewQueue: 'Review queue',
    weekSelfService: 'BLIK (week)',
    weekBoltDaily: 'Bolt daily (week)',
    payoutsUnit: 'payouts',
    integrationsStatus: 'Integrations status',
    intOk: 'OK',
    intError: 'error',
    intNotConfigured: 'not configured',
    enabled: 'enabled',
    disabled: 'disabled',
    feesTodayCompany: 'Fees today (company)',
    feesWeekCompany: 'Fees week (company)',
    fromDailyFees: 'from 30 PLN fees',
    avgBlikAmount: 'Avg BLIK amount',
    perRequest: 'per request',
    successRate: 'Success rate',
    requestsUnit: 'requests',
    monthSummary: 'Monthly summary',
    totalPaid: 'paid',
    feesToCompany: 'company revenue',
    driversEarningsToday: 'Drivers earnings (current period)',
    driversCashToday: 'Cash in drivers pockets',
    driversWithEarnings: 'drivers with earnings',
    inDriverPockets: 'already taken by drivers',
    companyRevenueToday: 'Company revenue today',
    earningsBySubCompanyToday: 'Earnings per branch (current period)',
    earningsTotal: 'Earnings',
    cashCollectedTotal: 'Cash collected',
    totalLabel: 'TOTAL',
    edit: 'Edit dashboard',
    editDone: 'Save layout',
    editReset: 'Reset',
    editHint: 'Drag widgets onto the dashboard. Resize or hide on each card.',
    noHiddenWidgets: 'All widgets are on the dashboard',
    layoutSaved: 'Layout saved',
    layoutReset: 'Layout reset to default',
    confirmReset: 'Reset layout to default?',
    apiLiveTitle: 'Live from API (Bolt + Uber)',
    apiLiveHint: 'Fetches current earnings from API for selected date range',
    apiLiveClickFetch: 'Click "Fetch" to pull data from API',
    apiLiveLoading: 'Fetching from Bolt/Uber API...',
    fetch: 'Fetch',
    apiGross: 'Gross',
    apiNet: 'Net',
    apiCash: 'Cash',
    apiDrivers: 'drivers',
    apiOrders: 'orders',
    perSource: 'Per source',
    perBranch: 'Per branch',
    apiUnmatched: '{n} API drivers not in our DB.',
    syncDrivers: 'Sync drivers',
    legacyTitle: 'Full dashboard (classic)',
    hideWidget: 'Hide widget',
    revenueChartTitle: 'Revenue (chart)',
    earningsByPlatformPie: 'Earnings per app (pie chart)',
    platformCommissions: 'App commissions',
    appEarningsSummary: 'App earnings',
    financeBreakdown: 'Company finance — breakdown',
    revenueBreakdown: 'Company revenue — components',
    costBreakdown: 'Fixed costs',
    chartSourceDb: 'from DB',
    chartSourceApi: 'from API (live)',
    fetchFromApi: 'Fetch from API',
    switchToDb: 'Back to DB',
    chartApiTimedOut: 'API fetch exceeded 45s — showing partial results. Try a shorter range.',
    chartFetchTime: 'Fetch time',
  },
  generationReport: {
    title: 'Settlement generation report',
    feesTitle: 'Fees added to debt: {count}',
    feesBoundary: 'Separate fee-charging stage. These are not created payouts; the list may include people outside the candidate pool above.',
    feesIncomplete: 'The fee stage was not completed or did not start. The list may be partial.',
    noFees: 'No charges recorded in this report.',
    lastReport: 'Last report', openReport: 'Open report', history: 'History in Audit Logs',
    historyAccess: 'Saved reports are available in Audit Logs to users with access to that section.',
    summary: 'Created: {created} · skipped: {skipped} · failed: {failed} · not processed: {notProcessed}',
    partialFailure: 'Generation was interrupted. Some settlements may already exist. Check each result before retrying; this report does not mean the operation was rolled back.',
    notSaved: 'The report could not be saved to history. It is available only in this view until you leave. Do not regenerate solely to save a report.',
    scopeTitle: 'Scope of this operation', period: 'Period', search: 'Search used for generation', noSearch: 'No search filter',
    departments: 'Departments (filter IDs)', allDepartments: 'All available within the company scope',
    schedule: 'Schedule', allSchedules: 'All', threshold: 'Payout threshold',
    unknownThreshold: 'Not determined before the interruption', greaterThan: 'Strictly above {amount}',
    candidates: 'Considered candidates', unknownCandidates: 'Candidate list not determined', onlyDriver: 'Only driver (ID)', mode: 'Mode', onDemand: 'On demand',
    scopeBoundary: 'This report covers only considered candidates from the positive-total pool after applying filters and the retrieval limit. It does not cover all drivers or people outside that pool, and does not explain their absence.',
    findDriver: 'Search driver, ID or reason in this report', result: 'Result', allResults: 'All results',
    driver: 'Driver', reason: 'Reason / details', candidateAmount: 'Amount before generation', payout: 'Created payout',
    comparison: 'Value: {actual} · required minimum: {required}', settlementId: 'Settlement ID',
    noMatches: 'No results for the selected report filters.', noCandidates: 'The report contains no considered candidates. Check the scope and any error above.',
    rows: 'Rows {from}–{to} of {total}', runId: 'Run ID',
    savedHint: 'Report saved in Audit Logs (access depends on permissions).', memoryHint: 'Report has not been saved to history.',
    counts: { created: 'Created', skipped: 'Skipped', failed: 'Failed', notProcessed: 'Not processed' },
    outcomes: { CREATED: 'Created', SKIPPED: 'Skipped', FAILED: 'Failed', NOT_PROCESSED: 'Not processed' },
    schedules: { DAILY: 'Daily', WEEKLY: 'Weekly', EVERY_2_WEEKS: 'Every 2 weeks', MONTH: 'Monthly', MONTHLY: 'Monthly' },
    legacyTitle: 'Finished — legacy response', legacyHint: 'The backend did not return a detailed report. This response does not confirm that a settlement was created for every person.',
    legacyOdometer: 'Skipped — missing odometer reading:', legacyInspection: 'Skipped — inspection summons:', legacyFees: 'Fee added to debt:',
    requestFailed: 'The full generation result could not be confirmed. Check settlements and Audit Logs before retrying.', errorTitle: 'Completion not confirmed',
    refreshFailed: 'The settlement list could not be refreshed. The received report is still available; check that the list is up to date before another operation.',
  },
  settlements: {
    title: 'Settlements',
    filters: 'Filters',
    department: 'Department',
    week: 'Week',
    settlementType: 'Settlement Type',
    tableVisibility: 'Table Visibility',
    negative: 'Negative balance',
    deletedDrivers: 'Deleted drivers',
    settle: 'Settle!',
  },
  debtors: {
    title: 'Debtors',
    subtitle: 'Drivers with a cumulative negative balance (sum of all settlements). Updates with every new settlement.',
    totalDebt: 'Total debt',
    debtorsCount: 'debtors',
    search: 'Search (name, surname, phone)',
    refresh: 'Refresh',
    empty: 'No debtors — everyone is positive or zero.',
    driver: 'Driver',
    type: 'Type',
    balance: 'Balance (debt)',
    earnings: 'Earnings',
    rent: 'Rent',
    weeksTitle: 'Weekly settlements',
    week: 'Week',
    weekBalance: 'Week balance',
  },
  payouts: {
    title: 'Payouts',
    filters: 'Filters',
    branch: 'Branch',
    week: 'Week',
    settlementType: 'Settlement Type',
    receiptsTab: 'Receipts',
    costInvoicePool: 'Cost Invoice Pool',
    collapse: 'Collapse',
    expand: 'Expand',
    pool: 'Pool',
    allocated: 'Allocated',
    remaining: 'Remaining',
    invoiceCount: 'Invoice count',
    activeAllocations: 'Active allocations',
    amount: 'Amount',
    admin: 'Admin',
    action: 'Action',
    revert: 'Revert',
    publishAll: 'Publish All',
    unpublishAll: 'Unpublish All',
    revertAll: 'Revert All',
    wiresPaid: 'Wires Paid',
    allPaid: 'All Paid',
    generateBaskets: 'Generate baskets',
    invoiceBased: 'invoice based',
    uploaded: 'Uploaded',
    invoicePendingReview: 'Pending review',
    invoiceAccepted: 'Accepted',
    invoiceRejected: 'Rejected',
    acceptInvoice: 'Accept invoice',
    rejectInvoice: 'Reject invoice',
    rejectReasonTitle: 'Invoice rejection reason',
    rejectReasonHint: 'E.g. wrong amount, missing cash note…',
    acceptInvoiceConfirm: 'Accept this invoice? This unblocks the payout.',
    markInvoice: 'Mark Invoice',
    uploadInvoice: 'Upload Invoice',
    paidWire: 'Paid (wire)',
    paidCash: 'Paid (cash)',
    publish: 'Publish',
    unpublish: 'Unpublish',
    allocateFromPool: 'Allocate from cost pool',
    remainingInPool: 'Remaining in pool',
    currentCostReimbursement: 'Current cost reimbursement',
    currentRent: 'Current rent',
    amountPLN: 'Amount (PLN)',
    allocate: 'Allocate',
    uploadInvoiceTitle: 'Upload invoice',
    selectInvoiceFile: 'Select invoice file',
    upload: 'Upload',
    invoicePreview: 'Invoice preview',
    generateTransfersTitle: 'Generate transfer baskets',
    bankFormat: 'Bank format',
    senderAccount: 'Sender account',
    senderName: 'Sender name (from company)',
    transferDescription: 'Separate files will be generated for each transfer type: contract payment, cost reimbursement, rent, bailiff. Format: ELIXIR-O (CSV).',
    generate: 'Generate',
    cashReceiptTitle: 'Cash payment receipt',
    driverSignature: 'Driver signature (recipient)',
    workerSignature: 'Worker signature (payer)',
    saveWithoutSignature: 'Save without signature',
    saveAndPrint: 'Save and print',
    receiptFilters: 'Receipt filters',
    searchDriver: 'Search driver',
    cashReceipts: 'Cash payment receipts',
    driverSigned: 'Driver signature',
    noDriverSignature: 'No driver signature',
    workerSigned: 'Worker signature',
    noWorkerSignature: 'No worker signature',
    printReceipt: 'Print receipt',
  },
  contracts: {
    title: 'Contracts',
    filters: 'Filters',
    branch: 'Branch',
    week: 'Week',
    settlementType: 'Settlement Type',
  },
  receipts: {
    title: 'Receipts',
    month: 'Month',
    searchDriver: 'Search driver',
    downloadZip: 'Download ZIP',
    downloadPdf: 'Download PDF',
  },
  costInvoices: {
    title: 'Cost Invoices',
    uploadTitle: 'Upload Invoice',
    file: 'File',
    brutto23: 'Amount (Gross 23%)',
    netto23: 'Amount (Net 23%)',
    brutto8: 'Amount (Gross 8%)',
    netto8: 'Amount (Net 8%)',
    brutto5: 'Amount (Gross 5%)',
    netto5: 'Amount (Net 5%)',
    brutto0: 'Amount (Gross 0%)',
    netto0: 'Amount (Net 0%)',
  },
  incomes: {
    title: 'Incomes',
    formTitle: 'Income Form',
    file: 'File',
    brutto: 'Amount (Gross)',
    netto: 'Amount (Net)',
    taxPercent: 'Tax (%)',
  },
  tasks: {
    myTasks: 'Mine',
    myTasksTitle: 'My tasks',
    popup: {
      title: 'New task',
      dueTitle: 'Task deadline approaching',
      newLabel: 'Waiting to be started',
      dueLabel: 'Due within 24 hours',
      counter: 'Task {current} of {total}',
      start: 'Start task',
      ack: 'Acknowledge',
      snooze: 'Remind me in 1 hour',
      postpone: "Postpone 1 day",
      deadline: 'Due date',
    },
    title: 'Tasks',
    active: 'Active',
    archive: 'Archive',
    archiveTitle: 'Task Archive',
    statistics: 'Statistics',
    addTask: 'Add task',
    editTask: 'Edit task',
    deleteTask: 'Delete task',
    newTask: 'New task',
    create: 'Create',
    taskTitle: 'Task title',
    taskDescription: 'Task description',
    taskType: 'Task type',
    priority: 'Priority',
    recordType: 'Record type',
    linkedRecord: 'Linked record',
    assignTo: 'Assign to',
    dueDate: 'Due date',
    notes: 'Notes',
    addNote: 'Add note',
    noMessages: 'No messages',
    unassigned: 'Unassigned',
    typeInternal: 'Internal',
    typeLinked: 'Linked',
    clickToChangeStatus: 'Click to change status',
    statisticsTitle: 'Task statistics',
    tasksByUsers: 'Tasks by users',
  },
  notifications: {
    read: 'Read',
    unread: 'Unread',
    detailsTitle: 'Notification details',
    text: 'Text',
    createdAt: 'Created at',
    details: 'Details',
    type: 'Type',
    reason: 'Reason',
    approvedById: 'Approved by ID',
    approvedAt: 'Approved at',
    rejectedById: 'Rejected by ID',
    rejectedAt: 'Rejected at',
  },
  notificationLogs: {
    title: 'Notification send history',
    entries: 'entries',
    searchPlaceholder: 'Search (type, email, phone, content)',
    channel: 'Channel',
    refresh: 'Refresh',
    detailTitle: 'Notification details',
    type: 'Type',
    priorityLabel: 'Priority',
    recipientId: 'Recipient ID',
    phone: 'Phone',
    email: 'Email',
    messageTitle: 'Title',
    content: 'Content',
    errorLabel: 'Error',
  },
  chat: {
    companyChat: 'Company communication',
    channels: 'Channels',
    online: 'online',
    selectChannel: 'Select channel',
    emptyChannel: 'Channel is empty. Write the first message!',
    file: 'File',
    photo: 'Photo',
    template: 'Template',
    messageTo: 'Message to',
    editChannel: 'Edit channel',
    newChannel: 'New channel',
    createChannel: 'Create',
    channelName: 'Channel name',
    channelNameHint: 'e.g. Important info, Schedule, Settlements',
    channelType: 'Channel type',
    channelColor: 'Channel color',
    channelIcon: 'Channel icon',
    channelIconHint: 'Pick from the palette or type your own emoji',
    confirmation: 'Confirmation',
    deleteChannelConfirm: 'Delete channel #{name}? All messages will be lost.',
  },
  sms: {
    sendSms: 'Send SMS',
    sendHistory: 'Send history',
    replies: 'Replies',
    composerEyebrow: 'Message center',
    composerTitle: 'Write a clear SMS',
    composerSubtitle: 'Create messages with paragraphs and immediately see what the recipient will receive.',
    livePreview: 'Live preview',
    chooseRecipients: 'Choose recipients',
    chooseRecipientsHint: 'Send a message to one person or an entire group.',
    readyRecipients: 'Ready recipients',
    writeMessage: 'Write a message',
    writeMessageHint: 'Line breaks, spacing and paragraphs will be preserved in the sent SMS.',
    quickInsert: 'Quick insert',
    greeting: 'Greeting',
    newParagraph: 'New paragraph',
    btpSignature: 'BTP signature',
    messagePlaceholder: 'Hello,\n\nenter your message here...\n\nRegards,\nBTP Team',
    characters: 'Characters',
    smsParts: 'SMS parts',
    encoding: 'Encoding',
    currentPart: 'Current part',
    remainingInPart: 'Remaining in this part: {count}',
    unicodeHint: 'Polish characters and emoji enable Unicode: 70 characters in the first SMS and 67 in each following part.',
    stripPolish: 'Strip Polish characters (cheaper SMS — 160 chars per part instead of 70)',
    previewLabel: 'message preview',
    emptyPreview: 'Your message will appear here exactly as written, including paragraphs.',
    justNow: 'now',
    totalEstimate: 'Estimate: {recipients} recipients × {parts} parts = {total} SMS',
    formattingPreserved: 'Paragraphs and spacing shown in the preview will be preserved.',
    templates: 'Templates',
    schedule: 'Schedule',
    limitReached: 'Message limit reached',
    clearDraftTitle: 'Clear the draft?',
    clearDraftText: 'The message and selected recipients will be removed.',
    singlePerson: 'Single person',
    bulkSend: 'Bulk send',
    recipient: 'Recipient',
    searchByNameOrPhone: 'Search by name, surname or phone number...',
    noResults: 'No results',
    phoneNumber: 'Phone number',
    phoneRequired: 'Phone number is required',
    targetGroup: 'Target group',
    department: 'Department',
    selectPeople: 'Select people',
    typeToSearch: 'Type to search...',
    recipientsCount: 'Recipients',
    people: 'people',
    message: 'Message',
    total: 'Total',
    smsMessage: 'SMS message',
    contentRequired: 'Content is required',
    maxChars: 'Max 320 characters',
    chars: 'characters',
    allowReply: 'Allow reply',
    send: 'Send',
    sendTo: 'Send to',
    clear: 'Clear',
    smsHistory: 'SMS send history',
    single: 'Single',
    bulk: 'Bulk',
    messageDetails: 'Message details',
    sender: 'Sender',
    content: 'Content',
    person: 'Person',
    smsReplies: 'SMS Replies',
    reply: 'Reply',
    markRead: 'Mark as read',
    bulkConfirmTitle: 'Bulk send confirmation',
    bulkConfirmText: 'Are you sure you want to send SMS to {count} people? This action cannot be undone.',
    totalSmsCount: 'Total SMS count',
    confirmAndSend: 'Confirm and send',
  },
  email: {
    title: 'Email',
    sendEmail: 'Send email',
    sendHistory: 'Send history',
    singlePerson: 'Single person',
    bulkSend: 'Bulk send',
    recipient: 'Recipient',
    searchByNameOrEmail: 'Search by name or email',
    noResults: 'No results',
    email: 'Email address',
    emailRequired: 'Email address is required',
    targetGroup: 'Target group',
    department: 'Department',
    selectPeople: 'Select people',
    typeToSearch: 'Start typing to search',
    recipientsCount: 'Recipients',
    people: 'people',
    subject: 'Subject',
    subjectRequired: 'Subject is required',
    maxChars: 'Character limit exceeded',
    message: 'Message',
    emailMessage: 'Message body',
    contentRequired: 'Content is required',
    send: 'Send',
    sendTo: 'Send to',
    clear: 'Clear',
    emailHistory: 'Email history',
    all: 'All',
    single: 'Single',
    bulk: 'Bulk',
    messageDetails: 'Message details',
    sender: 'Sender',
    content: 'Content',
    person: 'Person',
    recipientColumn: 'Recipient(s)',
    actions: 'Actions',
    sentTitle: 'Email sent!',
    sendFailed: 'Failed to send email',
    bulkDoneTitle: 'Send completed!',
    bulkQueuedTitle: 'Sending started',
    bulkQueuedText: 'Messages go out in the background, spaced out to keep the mailbox from being blocked. You can follow the progress in the send history.',
    sent: 'Sent',
    errors: 'Errors',
    detailFailed: 'Failed to load details',
    resentTitle: 'Resent!',
    bulkConfirmTitle: 'Bulk send confirmation',
    bulkConfirmText: 'Are you sure you want to send email to {count} people? This action cannot be undone.',
    confirmAndSend: 'Confirm and send',
    status: {
      SENT: 'Sent',
      FAILED: 'Failed',
      PARTIAL: 'Partial',
      PENDING: 'Pending',
    },
  },
  policySales: {
    title: 'Policy Sales',
    summaryTotal: 'Total of all policies',
    summaryPaid: 'Paid',
    summaryUnpaid: 'Unpaid',
    policiesCount: 'Policy count',
    addButton: 'Add policy',
    addPolicy: 'Add policy',
    editPolicy: 'Edit policy',
    buyerName: 'Purchased by',
    policyNumber: 'Policy no.',
    subject: 'Policy subject',
    amount: 'Amount',
    paid: 'Paid',
    unpaid: 'Unpaid',
    paidCheckbox: 'Policy paid',
    paidAt: 'Payment date',
    file: 'File',
    attachment: 'Attachment (policy scan)',
    currentFile: 'Current file',
    replaceFileHint: 'choose a new one to replace',
    filterAll: 'All',
    monthFilter: 'Month',
    fieldRequired: 'Field required',
    invalidAmount: 'Invalid amount, e.g. 1234.56',
    loadFailed: 'Failed to load policy list',
    saveFailed: 'Failed to save policy',
    added: 'Policy added',
    updated: 'Policy updated',
    deleted: 'Policy deleted',
    deleteFailed: 'Failed to delete policy',
    downloadFailed: 'Failed to download file',
    markPaidTitle: 'Mark policy as paid?',
    markUnpaidTitle: 'Mark policy as unpaid?',
    deleteTitle: 'Delete policy?',
  },
  serviceApprovals: {
    title: 'Service Approvals',
    pendingInfo: 'Services awaiting approval',
    car: 'Vehicle',
    driver: 'Driver',
    serviceType: 'Service type',
    workshop: 'Workshop',
    cost: 'Cost',
    description: 'Description',
    attachments: 'Invoices / attachments',
    attachment: 'Attachment',
    approve: 'Approve',
    reject: 'Reject',
    approved: 'Approved',
    rejected: 'Rejected',
    approveTitle: 'Approve this service?',
    rejectTitle: 'Reject this service?',
    rejectReasonPlaceholder: 'Rejection reason (optional)',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    loadFailed: 'Failed to load the service list',
    actionFailed: 'Failed to save the decision',
    fileError: 'Failed to open the attachment',
  },
  documentTemplates: {
    title: 'Document Templates',
    uploadTemplate: 'Upload template',
    templateName: 'Template name',
    uploadDocx: 'Upload .docx file',
    extractedVariables: 'Extracted variables',
    requiredForDriver: 'Required for driver',
    upload: 'Upload',
  },
  pendingDocuments: {
    title: 'Pending Documents',
    docsPerPage: 'Documents per page:',
    of: 'of',
    loadingDocs: 'Loading documents...',
    noDocsToShow: 'No documents to display',
    signed: 'Signed',
    requiredBadge: 'REQUIRED',
    optional: 'Optional',
    signature: 'Signature',
    documentSignature: 'Document signature',
    document: 'Document',
    signatureDate: 'Signature date',
    driverSignature: 'Driver signature',
    documentPreview: 'Document preview',
  },
  documentsRepository: {
    title: 'Documents Repository',
    addDocument: 'Add document',
    company: 'Company',
    signedByDrivers: 'Signed by drivers',
    searchDocuments: 'Search documents...',
    contracts: 'Contracts',
    protocols: 'Protocols',
    declarations: 'Declarations',
    regulations: 'Regulations',
    other: 'Other',
    noDocuments: 'No documents',
    searchDriver: 'Search driver...',
    noSignedDocuments: 'No signed documents',
    kind: 'Kind',
    titleDescription: 'Title / Description',
    additional: 'Additional',
    files: 'Files',
    documentLabel: 'Document',
    protocolLabel: 'Protocol',
    accepted: 'Accepted',
    documentName: 'Document name',
    nameRequired: 'Name is required',
    category: 'Category',
    categoryRequired: 'Category is required',
    file: 'File',
    fileRequired: 'File is required',
  },
  fleet: {
    title: 'Fleet',
    cars: 'Cars',
    subFleets: 'Sub-Fleets',
    endingRent: 'Ending Rent',
    endDate: 'End Date',
    carPhotos: 'Car Photos',
    notes: 'Notes',
    dieselLevel: 'Diesel level',
    petrolLevel: 'Petrol level',
    lpgLevel: 'LPG level',
    protocolComparison: 'Protocol Comparison',
    subFleet: 'Sub-Fleet',
    new: 'New',
    subFleetName: 'Sub-fleet name',
    parentSubFleet: 'Parent sub-fleet (optional)',
    assignCarToSubFleet: 'Assign car to sub-fleet',
    assignToMainFleet: 'Assign to main fleet',
    newSubFleet: 'New sub-fleet',
    ownerData: 'Owner Data',
    fees: 'Fees',
    settlement: 'Settlement',
    carsAndDrivers: 'Cars & Drivers',
    ownerFullName: 'Owner full name',
    companyName: 'Company name',
    address: 'Address',
    phone: 'Phone',
    bankAccountNo: 'Bank account number',
    saveOwnerData: 'Save owner data',
    feeType: 'Fee type',
    fixedBaseAmount: 'Fixed base amount (PLN)',
    billingPeriod: 'Billing period',
    dayOfMonth: 'Day of month (settlement)',
    saveFeeConfig: 'Save fee configuration',
    month: 'Month',
    year: 'Year',
    calculateSettlement: 'Calculate settlement',
    totalRent: 'Total rent',
    btpFee: 'BTP fee',
    ownerPayout: 'Owner payout (net)',
    details: 'Details',
    item: 'Item',
    amount: 'Amount',
    noCarsAssigned: 'No cars assigned',
    vehicleForm: 'Vehicle Form',
    make: 'Make',
    model: 'Model',
    color: 'Color',
    plate: 'License plate',
    registration: 'Registration',
    productionYear: 'Production Year',
    serviceDate: 'Service Date',
    insuranceDate: 'Insurance Date',
    policyNumber: 'Policy number',
    insurerName: 'Insurer name',
    inspectionDate: 'Inspection Date',
    inspectionValidTo: 'Inspection valid to',
    insuranceValidTo: 'Insurance valid to',
    lastService: 'Last service',
    wrapType: 'Wrap type',
    deposit: 'Deposit (PLN)',
    rentCost: 'Rent cost (PLN)',
    odometer: 'Odometer (km)',
    previousOdometer: 'Previous recorded odometer (km)',
    fuelType: 'Fuel type',
    sideNumber: 'Side number',
    companyCar: 'Company car?',
    fuelCard: 'Fuel Card',
    branch: 'Branch',
  },
  fleetDetails: {
    protocolComparison: 'Protocol Comparison',
    matching: 'Matching',
    different: 'Different',
    missingInOther: 'Missing in other',
    carManagement: 'Car Management',
    licenses: 'Licenses',
    rentProtocol: 'Rent Protocol',
    endRent: 'End Rent',
    endRentProtocol: 'End Rent Protocol',
    service: 'Service',
    crash: 'Crash',
    quickActions: 'Quick Actions',
    backToList: 'Back to list',
    compareProtocols: 'Compare Protocols',
    carHistoryManagement: 'Car History Management',
    assignLicenses: 'Assign Licenses',
    licenseNumber: 'License number',
    licenseExcerptNumber: 'License excerpt number',
    city: 'City',
    saveLicense: 'Save License',
    noLicenses: 'No saved licenses',
    saveRentProtocol: 'Save rent protocol',
    saveEndProtocol: 'Save end protocol',
    saveService: 'Save service',
    saveCrash: 'Save crash',
    searchHistory: 'Search in history',
    allOk: '✅ ALL OK!',
    sameState: 'Car returned in the same state',
    changesFound: 'FOUND {count} CHANGES IN CAR',
    before: 'BEFORE:',
    after: 'AFTER:',
    howToRead: 'HOW TO READ THIS?',
    greenLabel: 'Green',
    greenMeans: '= All good',
    redLabel: 'Red',
    redMeans: '= Issue to clarify',
    startDate: 'Start date',
    collectedDeposit: 'Collected deposit',
    depositMethod: 'Deposit method',
    handoverMileage: 'Mileage at handover (km)',
  },
  driverFleet: {
    title: 'Driver Fleet (private cars)',
    active: 'Active',
    pending: 'Pending',
    archive: 'Archive',
    pendingApproval: 'Pending approval',
    archiveTitle: 'Archive - deleted private cars',
    restore: 'Restore',
    assignDriver: 'Assign driver',
    assignDriverToVehicle: 'Assign driver to vehicle',
    vehicle: 'Vehicle',
    selectDriver: 'Select driver',
    driverNotFound: 'Driver not found',
    driverSearchHint: 'Enter name, surname or email',
    driversInDb: 'In database',
    skip: 'Skip',
    assign: 'Assign',
    editVehicle: 'Edit vehicle',
  },
  crashes: {
    addingCrash: 'Adding crash',
    category: 'Category',
    vehicleAndDriver: 'Vehicle and driver',
    insurer: 'Insurer',
    description: 'Description',
    documents: 'Documents',
    summary: 'Summary',
    step1Hint: 'Select the crash category and basic identification data.',
    step2Hint: 'Indicate the driver and vehicle involved in the crash.',
    step3Hint: 'Insurer data and policy / claim number.',
    step4Hint: 'Describe the circumstances of the crash — what, where, how.',
    step5Hint: 'Add crash photos, statements, police reports. Optional step.',
    step6Hint: 'Review data before saving. This information will be used for automatic document filling.',
    crashDate: 'Crash date',
    crashNumber: 'Crash number',
    vehicleOptional: 'Vehicle (optional)',
    vehicleOptionalHint: 'Skip if the crash does not concern a specific vehicle',
    insurerData: 'Insurer data',
    incidentDescription: 'Incident description',
    files: 'Files (photos, PDF)',
    vehicle: 'Vehicle',
    attachments: 'Attachments',
    saveCrash: 'Save crash',
    company: 'Company',
    cessions: 'Cessions',
    external: 'External crashes',
    rentCalculator: 'Rent calculator',
    rentCalculatorTitle: 'Replacement vehicle rent calculator',
    companyCrashes: 'Company crashes',
    externalCrashes: 'External crashes',
    downloadFiles: 'Download files',
    registrationNumber: 'Registration number',
    dailyRate: 'Daily rate (PLN)',
    vehicleCount: 'Vehicle count',
    dayCount: 'Day count',
    amountPerVehicle: 'Amount per vehicle',
    clear: 'Clear',
    copy: 'Copy',
    copySummary: 'Copy summary',
    saveCalculation: 'Save calculation',
    calculationHistory: 'Calculation history',
    searchByPlateOrCrash: 'Search by plate / crash no.',
    savedDate: 'Saved date',
    plateOrCrashNo: 'Plate / Crash no.',
    period: 'Period',
    days: 'Days',
    rate: 'Rate',
    vehicles: 'Vehicles',
    total: 'Total',
    editCrash: 'Edit Crash',
    crashStatus: 'Crash status',
    addNewFiles: 'Add new files',
    newFilesPreview: 'New files preview',
    existingFiles: 'Existing files',
    file: 'File',
    descriptionPlaceholder: 'E.g. Collision at Marszałkowska / Al. Jerozolimskie intersection. A passenger car hit the back of a vehicle while changing lanes…',
  },
  crashDetails: {
    title: 'Vehicle crash history',
    addHistory: 'Add history',
    crashId: 'Crash ID',
    crashDescription: 'Crash description',
    visibleToDriver: 'Visible to driver',
    visibleToDriverHint: 'Check if the driver should see this note',
    files: 'Files',
    searchHistory: 'Search crash history',
    refreshData: 'Refresh data',
    crashHistory: 'Crash history',
    details: 'Details',
    noCrashHistory: 'No crash history for this vehicle',
    crashDetails: 'Crash details',
  },
  fuelCards: {
    title: 'Fuel Cards',
    fuelCard: 'Fuel Card',
    number: 'Number',
    provider: 'Provider',
  },
  carRent: {
    title: 'Car Rental',
    rentalForm: 'Rental Form',
    amount: 'Amount',
  },
  uploader: {
    importSettlements: 'Import settlements',
    importRental: 'Import rental',
    application: 'Application',
    template: 'Template',
    settlementFile: 'Settlement file',
    settlementName: 'Settlement name',
    import: 'Import',
  },
  auditLogs: {
    title: 'Audit Logs',
    exportCsv: 'Export CSV',
    searchPlaceholder: 'Search...',
    action: 'Action',
    role: 'Role',
    from: 'From',
    to: 'To',
    clear: 'Clear',
    noEntries: 'No entries',
    dateTime: 'Date/Time',
    user: 'User',
    target: 'Target',
    details: 'Details',
    endpoint: 'Endpoint',
    targetType: 'Target type',
    targetId: 'Target ID',
    targetDisplay: 'Concerns',
    ip: 'IP',
  },
  departaments: {
    title: 'Departments',
    form: 'Form',
  },
  documentFiller: {
    selectDocument: 'Select document',
    analyzeDocument: 'Analyze document',
    generateDocument: 'Generate document',
    generatedDocument: 'Generated document',
    downloadDocument: 'Download document',
  },
  importHistory: {
    title: 'Import History',
    weekFrom: 'Week from',
    weekTo: 'Week to',
    reImportSkipped: 'Re-import skipped',
    showSkipped: 'Show skipped',
    undoImport: 'Undo import',
    importCancelled: 'Import cancelled',
    downloadFile: 'Download file',
  },
  payoutConfig: {
    title: 'Payout Configuration',
    zusRatesByType: 'ZUS Rates by Type',
    total: 'Total',
    sickLeave: 'Sick Leave',
    social: 'Social',
    pitAdvance: 'PIT Advance',
    health: 'Health',
    settlementThreshold: 'Settlement Threshold',
    minSettlementAmount: 'Minimum settlement amount',
    zusType: 'ZUS Type',
    zusTotal: 'ZUS Total',
    suggested: 'Suggested',
    maxContract: 'Max Contract',
    receiptConfig: 'Receipt Configuration',
    itemDescription: 'Item description',
    paymentDays: 'Payment days',
    issuePlace: 'Place of issue',
    additionalNotes: 'Additional notes',
    minSettlementHint: 'Minimum amount to generate a settlement (default 201 PLN)',
  },
  pointsDrivers: {
    title: 'Driver Balances',
    searchDriver: 'Search driver',
    pointsCorrection: 'Points correction',
    saveCorrection: 'Save correction',
    pointsHistory: 'Points history',
  },
  pointsReferrals: {
    title: 'Referrals',
    awarded: 'Awarded',
    pendingStatus: 'Pending',
  },
  pointsReviews: {
    title: 'Reviews',
    reviewLink: 'Review link',
    screenshotPreview: 'Screenshot preview',
    openInNewTab: 'Open in new tab',
    rejectReview: 'Reject review',
  },
  pointsRewardOrders: {
    title: 'Reward Orders',
    issued: 'Issued',
  },
  pointsSettings: {
    pointRates: 'Point Rates',
    referralConditions: 'Referral conditions',
    addCondition: 'Add condition',
    saveConfig: 'Save configuration',
    rewardCatalog: 'Reward Catalog',
    regulation: 'Regulation',
    noRegulation: 'No regulation',
    uploadRegulation: 'Upload regulation',
    editReward: 'Edit reward',
    newReward: 'New reward',
  },
  skippedImport: {
    title: 'Skipped Imports',
    assign: 'Assign',
    selectDriver: 'Select driver',
    searchDriver: 'Search driver',
    noDriversFound: 'No drivers found',
  },
  subFleet: {
    title: 'Sub-Fleets',
    subtitle: 'Manage sub-fleets and owner settlements',
    newSubFleet: 'New sub-fleet',
    editSubFleet: 'Edit sub-fleet',
    owner: 'Owner',
    fees: 'Fees',
    settlement: 'Settlement',
    carsAndDrivers: 'Cars & Drivers',
    totalRent: 'Total rent',
    btpCommission: 'BTP commission',
    ownerPayout: 'Owner payout',
    item: 'Item',
    amount: 'Amount',
  },
  systemSettings: {
    tabletsTitle: 'Signature tablets',
    tabletsHint: 'Devices paired for signing payouts and the cash report. A signature request goes to the tablet seen most recently.',
    tabletsEmpty: 'No paired tablets. You can pair one from Payouts or the Cash report.',
    tabletName: 'Name',
    tabletPaired: 'Paired',
    tabletLastSeen: 'Last seen',
    tabletState: 'State',
    tabletActive: 'Receiving signatures',
    tabletSilent: 'Silent — will not receive a signature',
    tabletNeverSeen: 'never checked in',
    tabletRemove: 'Remove from list',
    tabletRemoveConfirm: 'Remove "{name}" from the device list? The tablet will have to be paired again.',
    tabletRemoved: 'Device removed',
    tabletRemoveError: 'Could not remove the device',
    title: 'System Settings',
    subtitle: 'Global application settings',
    systemLogo: 'System logo',
    logoHint: 'Upload the logo shown across the panel',
    superadminOnly: 'Superadmin only',
    driverTerms: 'Driver app terms of service',
    driverTermsHint: 'Upload a PDF with the terms — drivers must accept it when logging into the app',
    driverTermsNone: 'No terms document uploaded yet.',
    driverTermsPick: 'Choose a PDF file',
    driverTermsUpload: 'Upload terms',
    driverTermsUploaded: 'Terms document uploaded.',
    driverTermsUploadError: 'Failed to upload the terms document.',
    driverTermsPreviewError: 'Failed to open the terms preview.',
    driverTermsPdfOnly: 'The terms must be a PDF file.',
    driverTermsReacceptNote: 'After uploading a new file, all drivers will have to accept the terms again at their next login.',
    driverTermsAcceptances: 'Acceptance history',
    driverTermsAccepted: 'Accepted',
    driverTermsMissing: 'Not accepted',
    driverTermsCurrentVersion: 'Current version',
    driverTermsColDriver: 'Driver',
    driverTermsColVersion: 'Version',
    driverTermsColDate: 'Acceptance date',
    driverTermsColIp: 'IP address',
    driverTermsColPhone: 'Phone',
    driverTermsNoMissing: 'All active drivers have accepted the current version of the terms.',
    driverTermsAcceptancesError: 'Failed to load the acceptance history.',
    noLogo: 'No logo',
    unsavedPreview: 'Preview (unsaved)',
    currentLogo: 'Current logo',
    uploadLogo: 'Upload logo',
    uploadHint: 'Drag a file or click to select (PNG, JPG, SVG)',
    removeLogo: 'Remove logo',
    balancePln: 'Balance (PLN)',
    sendingActive: 'Sending active',
    recipientEmail: 'Recipient email address',
    saveBalance: 'Save balance',
    fetchCurrent: 'Fetch current',
    cashReportTitle: 'Cash report — automatic monthly sending',
    cashReportSubtitle: 'On the 1st of every month at 02:00 the report for the previous month (PDF + CSV) is sent to the provided e-mail address.',
    emailExample: 'accounting@company.com',
  },
  uploaderTemplates: {
    title: 'Import Templates',
    addFileCreateTemplate: 'Add file and create template',
    customVariables: 'Custom variables',
    addCustomVariable: 'Add variable',
    onlyOneCompany: 'At the moment, only one company can exist',
  },
  wiki: {
    backToWiki: 'Back to Wiki',
    newTab: 'New tab',
    tryAgain: 'Try again',
    previewNotAvailable: 'Preview not available',
    openInNewTab: 'Open in new tab',
    attachments: 'Attachments',
    noAttachments: 'No attachments',
    addAttachment: 'Add attachment',
    addDescription: 'Add description',
    editDescription: 'Edit description',
    descriptionPlaceholder: 'Description / instructions for the file (e.g. how to use it, what it covers)…',
    noPreviewForType: 'No preview for this file type',
    open: 'Open',
    confirmation: 'Confirmation',
    confirmDeleteArticle: 'Delete article',
    attachmentsWillBeDeleted: 'Attachments will be deleted.',
    searchArticle: 'Search article...',
    addArticle: 'Add article',
    newSection: 'New section',
    deleteSection: 'Delete section',
    noArticles: 'No articles',
    noArticlesHint: 'Add your first article to get started',
    deleteArticle: 'Delete article',
    newArticle: 'New article',
    articleTitle: 'Article title',
    articleTitlePlaceholder: 'e.g. How to add a driver',
    section: 'Section',
    addSectionFirst: 'Add a section first',
    changeFile: 'Change file',
    selectPdf: 'Select PDF',
    sectionName: 'Section name',
    sectionNamePlaceholder: 'e.g. Onboarding',
    sectionId: 'Section ID',
    icon: 'Icon',
    confirmDeleteMsg: 'Are you sure you want to delete',
    sectionDeleteWarning: 'All articles in this section will also be deleted.',
  },
  wykazKierowcy: {
    cityBranch: 'City / Branch',
    active: 'Active',
    pending: 'Pending',
    delisted: 'Delisted',
    archive: 'Archive',
    delistFromRegistry: 'Delist from registry',
    pendingApproval: 'Pending approval',
    delistedFromRegistry: 'Delisted from registry',
    driverArchive: 'Driver archive',
    restore: 'Restore',
    editDriver: 'Edit driver',
    addNewDriver: 'Add new driver',
    lp: 'No.',
    fullName: 'Full name',
    drivingLicense: 'Driving license (series/no.)',
    medicalCertNumber: 'Medical certificate no.',
    medicalExpiry: 'Medical certificate expiry',
    psychCertNumber: 'Psychological certificate no.',
    psychExpiry: 'Psychological certificate expiry',
    criminalRecord: 'Criminal record certificate',
    licenseType: 'License type',
    vehiclePlate: 'Vehicle plate',
    medicalCert: 'Medical certificate',
    psychCert: 'Psychological certificate',
    vehicle: 'Vehicle',
    addedBy: 'Added by',
    approvedBy: 'Approved by',
    rejectionReason: 'Rejection reason',
    delistedOn: 'Delisted on',
    delistedByPerson: 'Delisted by',
    rejectEntry: 'Reject entry',
    delistTitle: 'Delist from registry',
    delistDate: 'Delist date',
    saveDelist: 'Save delisting',
  },
  wykaz: {
    vehicles: {
      title: 'Vehicle registry',
      addButton: 'Add vehicle',
    },
    drivers: {
      title: 'Driver registry',
      addButton: 'Add driver',
    },
  },
  wykazPojazdy: {
    cityBranch: 'City / Branch',
    activeTab: 'Active',
    pendingTab: 'Pending',
    archiveTab: 'Archive',
    pendingApproval: 'Pending approval',
    vehicleArchive: 'Vehicle archive',
    restore: 'Restore',
    editVehicle: 'Edit vehicle',
    addNewVehicle: 'Add new vehicle',
    rejectEntry: 'Reject entry',
    vehicleLabel: 'Vehicle',
    rejectionReason: 'Rejection reason',
  },
  uber: {
    integrationTitle: 'Uber Integration',
    integrationHint: 'API credentials for fetching daily settlements from Uber (Supplier Platform)',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    secretPlaceholder: 'Enter new secret (leave empty to keep current)',
    testConnection: 'Test connection',
    saveCredentials: 'Save credentials',
    removeCredentials: 'Remove integration',
    notConfigured: 'Not configured',
    configured: 'Configured',
    lastTest: 'Last test',
    testOk: 'Connection works',
    testFailed: 'Connection failed',
    externalCompanyId: 'Uber org ID',
    confirmRemove: 'Remove Uber integration?',
  },
  uberDailyPayouts: {
    title: 'Daily Payouts (Uber)',
    subtitle: 'Uber API tree breakdown → formula → payout',
    unmappedWarning: 'Unknown Uber categories detected — some amounts may be ignored',
  },
  boltSync: {
    title: 'Sync Bolt drivers',
    subtitle: 'Auto-link Bolt UUIDs with our driver records',
    loadPreview: 'Load preview',
    applyChanges: 'Apply changes',
    applying: 'Applying...',
    totalBolt: 'Bolt drivers',
    alreadyLinked: 'Already linked',
    autoAssignTitle: 'Auto-matches',
    autoAssignHint: 'High-confidence matches (≥80 pts). Check to accept.',
    suggestionsTitle: 'Suggested matches',
    suggestionsHint: 'Uncertain matches (40-79 pts). Confirm each individually.',
    idConflictsTitle: 'ID conflict',
    idConflictsHint: 'All fields match but Bolt returned different UUID. Replace?',
    toCreateTitle: 'New drivers (in Bolt, not in our DB)',
    toCreateHint: 'These are in Bolt but not here. Create automatically?',
    ourDriver: 'Our driver',
    boltDriver: 'Bolt driver',
    score: 'Score',
    reasons: 'Matched on',
    currentBoltId: 'Current Bolt ID',
    newBoltId: 'New Bolt ID',
    acceptAll: 'Select all',
    rejectAll: 'Unselect all',
    cooperationTypeDefault: 'Default cooperation type for new',
    noMatches: 'No auto-matches',
    noSuggestions: 'No suggestions',
    noConflicts: 'No ID conflicts',
    noToCreate: 'All Bolt drivers already have accounts',
    applyResult: 'Assigned: {assigned}, conflicts: {conflicts}, created: {created}, errors: {errors}',
    noIntegration: 'Configure Bolt integration in System Settings first',
    runSync: 'Run sync',
  },
  bolt: {
    integrationTitle: 'Bolt Integration',
    integrationHint: 'API credentials for fetching daily settlements from Bolt',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    clientIdCurrent: 'Current Client ID',
    secretPlaceholder: 'Enter new secret (leave empty to keep current)',
    testConnection: 'Test connection',
    saveCredentials: 'Save credentials',
    removeCredentials: 'Remove integration',
    notConfigured: 'Not configured',
    configured: 'Configured',
    lastTest: 'Last test',
    testOk: 'Connection works',
    testFailed: 'Connection failed',
    externalCompanyId: 'Bolt company ID',
    confirmRemove: 'Remove Bolt integration?',
  },
  selfService: {
    title: 'BLIK Payouts',
    queueTitle: 'Payouts awaiting approval',
    historyTitle: 'BLIK payouts history',
    empty: 'No payouts awaiting approval',
    driver: 'Driver',
    phone: 'Phone',
    accountNo: 'Account',
    requestedAmount: 'Requested amount',
    availableAtRequest: 'Available at request',
    fee: 'Fee',
    status: 'Status',
    createdAt: 'Created',
    approve: 'Approve',
    reject: 'Reject',
    rejectReason: 'Rejection reason (optional)',
    confirmApprove: 'Approve payout?',
    confirmReject: 'Reject payout?',
    approved: 'Approved',
    rejected: 'Rejected',
    config: 'BLIK payouts configuration',
    enabled: 'Enable BLIK payouts',
    percentLimit: 'Percent limit (%)',
    autoApproveThreshold: 'Auto-approve threshold (PLN)',
    maxPerDay: 'Max payouts per day',
    startHour: 'Start hour (0-23)',
    endHour: 'End hour (0-23)',
    provider: 'Payment provider',
    providerStub: 'STUB (test)',
    providerAutopay: 'Autopay (BLIK)',
    providerTpay: 'Tpay (BLIK)',
    statuses: {
      REQUESTED: 'Requested',
      AUTO_APPROVED: 'Auto-approved',
      NEEDS_APPROVAL: 'Pending admin',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      PROCESSING: 'Processing',
      PAID: 'Paid',
      FAILED: 'Failed',
    },
  },
  dailyPayouts: {
    title: 'Daily Payouts (Bolt)',
    subtitle: 'Mini daily settlement: Bolt rides → same-day payout',
    date: 'Day',
    refresh: 'Refresh',
    generate: 'Generate transfers',
    generating: 'Generating...',
    alreadyGenerated: 'Already generated',
    noData: 'No rides for the selected day',
    totalOrders: 'Total orders',
    matchedDrivers: 'Matched drivers',
    unmatchedDrivers: 'Unmatched',
    unmatchedWarning: 'Some Bolt drivers are not in the database',
    unmatchedDetails: 'Unmatched drivers',
    driver: 'Driver',
    ordersCount: 'Orders',
    grossTotal: 'Gross',
    grossApp: 'Gross (app)',
    grossCash: 'Gross (cash)',
    cashCollected: 'Cash collected',
    tips: 'Tips',
    commission: 'Bolt commission',
    netEarnings: 'Bolt net',
    calculatedAmount: 'Calculated',
    fee: 'Fee',
    finalAmount: 'To transfer',
    status: 'Status',
    statusReady: 'Ready',
    statusAlreadyPaid: 'Paid',
    statusUnmatched: 'Driver unmatched',
    statusFormulaError: 'Formula error',
    statusNoAmount: 'No amount',
    generateSuccess: 'Created {count} transfers',
    generatePartial: '{created} created, {skipped} skipped',
    formulaErrorTooltip: 'Missing MathEq for cooperation type or formula error',
    configureBoltFirst: 'Configure Bolt integration in System Settings first',
    freeNowComingSoon: 'FreeNow integration — coming later. For now you can import CSVs via the Importer.',
    integrationHint: 'Generated advances will appear in the next transfer basket under Payouts tab.',
    markPaid: 'Mark as paid',
    recentPayouts: 'Recent daily payouts',
    paid: 'Paid',
    pending: 'Pending',
  },
}
